import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import {URL, ADMIN} from '../../../lib/lib.js';
import "./component.css";

const Component = () => {
  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordShown, setPasswordShown] = useState({ old: false, new: false });

  const togglePasswordVisibility = (field) => {
    setPasswordShown((prevState) => ({ ...prevState, [field]: !prevState[field] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(URL + ADMIN.change_password, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body : JSON.stringify({email, oldPassword, newPassword }),
          credentials: 'include'
      });;

      if (response.status === 200) {
        alert("Password changed successfully!");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      alert(error.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <div id='change-password'>
      <div className='container-fluid'>
        <div className='row profile-my_flx_profile_up mt-5 pt-5'>
          <div className='col-xl-2 col-lg-3 col-md-2 profile-pro1 profile-admin'>
            {/* <Link to="/profile">
              <div className='profile-goBack'>
                <button className='profile-back'>
                  <i className="ri-arrow-left-s-line profile-lefticon"></i>
                </button>
              </div>
            </Link> */}
          </div>
          <div className='col-xl-8 col-lg-6 col-md-8'>
            <div className='profile-my_form_signup_profile'>
              <form onSubmit={handleSubmit}>
                <p className='profile-login_head'>Change Password</p>

                <div className="mb-3">
                  <label className="form-label profile-user_label">Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control"
                    placeholder="Enter Email"
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label profile-user_label">Old Password</label>
                  <div className="profile-inputContainer">
                    <input
                      type={passwordShown.old ? "text" : "password"}
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      className="form-control"
                      placeholder="Enter Old Password"
                      required
                    />
                    <span onClick={() => togglePasswordVisibility('old')} className="eye-icon">
                      {passwordShown.old ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label profile-user_label">New Password</label>
                  <div className="profile-inputContainer">
                    <input
                      type={passwordShown.new ? "text" : "password"}
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      className="form-control"
                      placeholder="Enter New Password"
                      required
                    />
                    <span onClick={() => togglePasswordVisibility('new')} className="eye-icon">
                      {passwordShown.new ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>

                <button type="submit" className="profile-submit_bot1">Change Password</button>
              </form>
            </div>
          </div>
          <div className='col-xl-2 col-lg-3 col-md-2'></div>
        </div>
      </div>
    </div>
  );
};

export default Component;
